module.exports = __webpack_public_path__ + "img/b82dfbe.png";